import { del, get, getDownload, post, put, urlApiTegra } from "../../../service/api";
import { UserSchedule, UserScheduleOptimization } from "../model";

const postUsers = (dadosBody: object, token: string) => {
  return post(`${urlApiTegra}/users`, dadosBody, token);
};

const getUsers = (token: string) => {
  return get(`${urlApiTegra}/users`, token);
};

const getUsersById = (token: string, userId: number) => {
  return get(`${urlApiTegra}/users/${userId}`, token);
};

const getProfiles = (token: string) => {
  return get(`${urlApiTegra}/profiles`, token);
};

const putUsers = (dadosBody: object, id: any, token: string) => {
  return put(`${urlApiTegra}/users/${id}`, dadosBody, token);
};

const deleteUsers = (id: any, token: string) => {
  return del(`${urlApiTegra}/users/${id}`, token);
};

const getCenterOfCust = (token: string) => {
  return get(`${urlApiTegra}/cost_center`, token);
};

const getSeniority = (token: string) => {
  return get(`${urlApiTegra}/seniority`, token);
};

const postBenefits = (token: string, dadosBody: object) => {
  return post(`${urlApiTegra}/cost-calculation/benefits`, dadosBody, token);
};

const postCalcs = (token: string, dadosBody: object) => {
  return post(`${urlApiTegra}/cost-calculation`, dadosBody, token);
};

const getUserScheduleById = (token: string, userId: number): Promise<UserSchedule> => {
  return get(`${urlApiTegra}/user_schedule/${userId}`, token);
};

const getUserScheduleNext = (token: string): Promise<UserScheduleOptimization[]> => {
  return get(`${urlApiTegra}/user_schedule/next-scheduled`, token);
};

const postUserSchedule = (token: string, dadosBody) => {
  return post(`${urlApiTegra}/user_schedule`, dadosBody, token);
};

const putUserSchedule = ({ token, dadosBody, id }) => {
  return put(`${urlApiTegra}/user_schedule/${id}`, dadosBody, token);
};

const deleteUsersSchedule = (id: any, token: string) => {
  return del(`${urlApiTegra}/user_schedule/${id}`, token);
};

interface csvUserDowloan {
  token?: string;
  query?: string;
}

const csvUserDowloan = ({ token, query }: csvUserDowloan) => {
  return getDownload(`${urlApiTegra}/users/download${query}`, token as string).then((data) => data?.text());
};

const getProjectsByUser = (token: string, id: string) => {
  return get(`${urlApiTegra}/projects/user/${id}`, token);
};

const getProjectsById = (token: string, id: string) => {
  return get(`${urlApiTegra}/projects/${id}`, token);
};

const getClientById = (token: string, id: string | number) => {
  return get(`${urlApiTegra}/client/${id}`, token);
};

export const serviceUsers = {
  postUsers,
  postBenefits,
  postCalcs,
  getUsers,
  getUsersById,
  putUsers,
  deleteUsers,
  getProfiles,
  getCenterOfCust,
  getSeniority,
  csvUserDowloan,
  putUserSchedule,
  postUserSchedule,
  getUserScheduleNext,
  getUserScheduleById,
  deleteUsersSchedule,

  getProjectsByUser,
  getProjectsById,
  getClientById,
};
